import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer style={{background: '#0f172a', color: 'white', padding: '5rem 0 2rem', position: 'relative', overflow: 'hidden'}}>
      {/* Background Pattern */}
      <div style={{position: 'absolute', top: 0, left: 0, right: 0, height: '1px', background: 'linear-gradient(90deg, transparent, #3b82f6, transparent)'}}></div>
      <div style={{position: 'absolute', top: 0, right: 0, width: '600px', height: '600px', background: 'radial-gradient(circle, rgba(59, 130, 246, 0.05) 0%, transparent 70%)', pointerEvents: 'none'}}></div>
      
      <div style={{maxWidth: '1200px', margin: '0 auto', padding: '0 2rem', position: 'relative', zIndex: 1}}>
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '3rem', marginBottom: '4rem'}}>
          <div style={{gridColumn: 'span 1'}}>
            <div style={{display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1.5rem', fontFamily: 'Inter', fontSize: '1.5rem', fontWeight: '800'}}>
              <svg width="44" height="44" viewBox="0 0 44 44" fill="none">
                <defs>
                  <linearGradient id="footerLogoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" style={{stopColor: '#3b82f6', stopOpacity: 1}} />
                    <stop offset="100%" style={{stopColor: '#1e40af', stopOpacity: 1}} />
                  </linearGradient>
                </defs>
                <rect width="44" height="44" rx="10" fill="url(#footerLogoGradient)"/>
                <path d="M14 30l8-16 8 16h-5l-3-6-3 6h-5z" fill="#ffffff"/>
                <circle cx="30" cy="14" r="4" fill="#fbbf24"/>
              </svg>
              <div style={{display: 'flex', flexDirection: 'column', lineHeight: '1.2'}}>
                <span style={{color: '#ffffff'}}>Aramco Leads Pro</span>
                <span style={{fontSize: '0.65rem', color: '#64748b', fontWeight: '500', letterSpacing: '0.5px'}}>CRM & LEAD GENERATION</span>
              </div>
            </div>
            <p style={{color: '#94a3b8', lineHeight: '1.8', marginBottom: '1.5rem', fontSize: '0.95rem'}}>
              Professional CRM and lead management platform with integrated customer communication tools.
            </p>
            <div style={{display: 'flex', gap: '1rem', marginTop: '1.5rem'}}>
              <div style={{width: '40px', height: '40px', borderRadius: '10px', background: 'rgba(59, 130, 246, 0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', transition: 'all 0.3s'}}>
                <svg width="20" height="20" fill="#3b82f6" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </div>
              <div style={{width: '40px', height: '40px', borderRadius: '10px', background: 'rgba(59, 130, 246, 0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', transition: 'all 0.3s'}}>
                <svg width="20" height="20" fill="#3b82f6" viewBox="0 0 24 24"><path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/></svg>
              </div>
              <div style={{width: '40px', height: '40px', borderRadius: '10px', background: 'rgba(59, 130, 246, 0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', transition: 'all 0.3s'}}>
                <svg width="20" height="20" fill="#3b82f6" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
              </div>
            </div>
          </div>
          
          <div>
            <h3 style={{fontSize: '0.875rem', fontWeight: '700', marginBottom: '1.5rem', color: '#ffffff', textTransform: 'uppercase', letterSpacing: '1px'}}>Platform</h3>
            <div style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
              <Link to="/features" style={{color: '#94a3b8', textDecoration: 'none', transition: 'color 0.3s', fontSize: '0.95rem', display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                <span style={{color: '#3b82f6'}}>→</span> Features
              </Link>
              <Link to="/how-it-works" style={{color: '#94a3b8', textDecoration: 'none', transition: 'color 0.3s', fontSize: '0.95rem', display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                <span style={{color: '#3b82f6'}}>→</span> How It Works
              </Link>
              <Link to="/pricing" style={{color: '#94a3b8', textDecoration: 'none', transition: 'color 0.3s', fontSize: '0.95rem', display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                <span style={{color: '#3b82f6'}}>→</span> Pricing
              </Link>
              <Link to="/integrations" style={{color: '#94a3b8', textDecoration: 'none', transition: 'color 0.3s', fontSize: '0.95rem', display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                <span style={{color: '#3b82f6'}}>→</span> Integrations
              </Link>
            </div>
          </div>
          
          <div>
            <h3 style={{fontSize: '0.875rem', fontWeight: '700', marginBottom: '1.5rem', color: '#ffffff', textTransform: 'uppercase', letterSpacing: '1px'}}>Legal & Compliance</h3>
            <div style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
              <Link to="/privacy" style={{color: '#94a3b8', textDecoration: 'none', transition: 'color 0.3s', fontSize: '0.95rem', display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                <span style={{color: '#3b82f6'}}>→</span> Privacy Policy
              </Link>
              <Link to="/terms" style={{color: '#94a3b8', textDecoration: 'none', transition: 'color 0.3s', fontSize: '0.95rem', display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                <span style={{color: '#3b82f6'}}>→</span> Terms of Service
              </Link>
              <Link to="/compliance" style={{color: '#94a3b8', textDecoration: 'none', transition: 'color 0.3s', fontSize: '0.95rem', display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                <span style={{color: '#3b82f6'}}>→</span> Compliance
              </Link>
              <Link to="/lending-compliance" style={{color: '#94a3b8', textDecoration: 'none', transition: 'color 0.3s', fontSize: '0.95rem', display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                <span style={{color: '#3b82f6'}}>→</span> Lending Compliance
              </Link>
              <Link to="/lending-faq" style={{color: '#94a3b8', textDecoration: 'none', transition: 'color 0.3s', fontSize: '0.95rem', display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                <span style={{color: '#3b82f6'}}>→</span> Lending FAQ
              </Link>
              <Link to="/opt-out" style={{color: '#94a3b8', textDecoration: 'none', transition: 'color 0.3s', fontSize: '0.95rem', display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                <span style={{color: '#3b82f6'}}>→</span> Opt-Out
              </Link>
            </div>
          </div>
          
          <div>
            <h3 style={{fontSize: '0.875rem', fontWeight: '700', marginBottom: '1.5rem', color: '#ffffff', textTransform: 'uppercase', letterSpacing: '1px'}}>Contact Us</h3>
            <div style={{display: 'flex', flexDirection: 'column', gap: '1rem', color: '#94a3b8', fontSize: '0.95rem'}}>
              <div>
                <p style={{color: '#ffffff', fontWeight: '600', marginBottom: '0.25rem'}}>Aramco 1 USA Corporation</p>
                <p style={{fontSize: '0.85rem', color: '#64748b'}}>DBA: Aramco Leads Pro</p>
              </div>
              <div>
                <p>11 Linden Ave</p>
                <p>Kearny, NJ 07032</p>
                <p>United States</p>
              </div>
              <div>
                <p style={{fontSize: '0.85rem', color: '#64748b'}}>EIN: 33-1773365</p>
              </div>
              <div style={{marginTop: '0.5rem'}}>
                <a href="mailto:info@aramcoleadspro.com" style={{color: '#3b82f6', textDecoration: 'none', display: 'block', marginBottom: '0.5rem'}}>
                  info@aramcoleadspro.com
                </a>
                <a href="mailto:support@aramcoleadspro.com" style={{color: '#3b82f6', textDecoration: 'none', display: 'block'}}>
                  support@aramcoleadspro.com
                </a>
              </div>
            </div>
          </div>
        </div>
        
        <div style={{paddingTop: '3rem', marginTop: '3rem', borderTop: '1px solid rgba(255,255,255,0.1)'}}>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem'}}>
            <p style={{color: '#64748b', fontSize: '0.875rem', margin: 0}}>
              © {new Date().getFullYear()} Aramco 1 USA Corporation. All rights reserved.
            </p>
            <div style={{display: 'flex', gap: '1.5rem', fontSize: '0.875rem'}}>
              <span style={{color: '#64748b'}}>🔒 Secure Platform</span>
              <span style={{color: '#64748b'}}>✓ TCPA Compliant</span>
              <span style={{color: '#64748b'}}>✓ A2P 10DLC Registered</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
